import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { CommonFilter } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class CommonReportService extends ApiService {
    endPoint = '/api/common';
    getDashboardAppeal(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/dashboard-appeal`, filter);
    }

    getDashboardReceived(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/dashboard-received`, filter);
    }

    getDashboardLethalOutcome(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/dashboard-lethal-outcome`, filter);
    }

    getDashboardOperationExecution(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/dashboard-operation-execution`, filter);
    }

    getDashboardTreatment(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/dashboard-treatment`, filter);
    }

    getDashboardBedOccupancy(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/dashboard-bed-occupancy`, filter);
    }
}
